import type { AgnosticAttribute } from '~~/types/commercetools';
import { RELATED_PRODUCT_LIMIT } from '~~/constants/commerceTools';

export default (accessoriesList: AgnosticAttribute) => {

  return {
    limit: RELATED_PRODUCT_LIMIT,
    ids: Object.values(accessoriesList).map((accessory) => accessory.id),
  };

};
